/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import { ContentContainer, DividerNew } from 'sarsaparilla';
import CampgroundPageV3PrimaryActionsPlaceholder from './placeholders/CampgroundPageV3PrimaryActionsPlaceholder';
import FacilitySnapshotPlaceholder from './FacilitySnapshot/placeholders/FacilitySnapshotPlaceholder';
import FindACampsiteSectionPlaceholder from './FindACampsite/placeholders/FindACampsiteSectionPlaceholder';
import HeroGallerySectionPlaceholder from './HeroGallery/placeholders/HeroGallerySectionPlaceholder';
import CampgroundPageV3HeaderPlaceholder from './Header/placeholders/CampgroundPageV3HeaderPlaceholder';
import MobileCoverageSectionPlaceholder from './MobileCoverage/placeholders/MobileCoverageSectionPlaceholder';
import PlanYourVisitPlaceholder from './PlanYourVisit/placeholders/PlanYourVisitPlaceholder';
import CampgroundPageV3ReviewsPlaceholder from './Reviews/placeholders/CampgroundPageV3ReviewsPlaceholder';

/** Full-page V3 skeleton while the campground query is loading. */
export default function CampgroundPageV3Loading() {
    return (
        <div className="rec-campground-page-v3">
            <HeroGallerySectionPlaceholder />
            <ContentContainer noTopBottomMargin={true} id="campground-page-v3-container">
                <CampgroundPageV3HeaderPlaceholder />
                <DividerNew className="campground-page-v3-divider" />
                <CampgroundPageV3PrimaryActionsPlaceholder />
                <FacilitySnapshotPlaceholder />
                <PlanYourVisitPlaceholder />
                <CampgroundPageV3ReviewsPlaceholder />
                <MobileCoverageSectionPlaceholder />
                <FindACampsiteSectionPlaceholder />
            </ContentContainer>
        </div>
    );
}
